module.exports = __webpack_public_path__ + "static/img/success-dyg.61bbb46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/success-dyg.png
// module id = aOrH
// module chunks = 0